import { c as _c } from "react/compiler-runtime";
import { SvgChevronright } from '@common/icon';
import { cn } from '@core/utils';
import { CustomLink } from '@/app/_components/CustomLink';
import { Image } from '@/components/client';
import { DONATION_ROUTES } from '@/constants';
import { NewBadge } from '../NewBadge';
import { Rating } from '../Rating';
interface GiftListItemProps {
  mainImageUrl: string;
  title: string;
  donationAmount?: number;
  reviewRating: number;
  reviewCount: number;
  productNumber: string;
  /** 지자체 정보 */
  institution?: {
    /** 지자체 slug(institutionSlugId) 또는 institutionId */
    id: number | string;
    logoUrl: string;
    name: string;
  };
  /** 성인전용 여부 */
  isAdult?: boolean;
  /** NEW 배지 표시 여부 */
  isNew?: boolean;
  /** 품절 여부 */
  isSoldOut?: boolean;
  onGiftLinkClick?: () => void;
  className?: string;
  /** 초기 로딩 우선순위 (LCP 최적화) */
  priority?: boolean;
}
export const GiftListItem = t0 => {
  const $ = _c(45);
  const {
    mainImageUrl,
    title,
    donationAmount,
    reviewRating,
    reviewCount,
    productNumber,
    institution,
    isAdult,
    isNew,
    isSoldOut,
    onGiftLinkClick,
    className,
    priority: t1
  } = t0;
  const priority = t1 === undefined ? false : t1;
  let t2;
  if ($[0] !== className) {
    t2 = cn("flex flex-col gap-8", className);
    $[0] = className;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== isNew) {
    t3 = isNew ? <div className="absolute left-0 top-0 z-[1]"><NewBadge /></div> : null;
    $[2] = isNew;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== productNumber) {
    t4 = DONATION_ROUTES.GIFTS_DETAIL.pathname({
      productNumber
    });
    $[4] = productNumber;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  const t5 = mainImageUrl || "/images/placeholder.png";
  const t6 = title || "\uB2F5\uB840\uD488 \uC774\uBBF8\uC9C0";
  let t7;
  if ($[6] !== priority || $[7] !== t5 || $[8] !== t6) {
    t7 = <Image className="aspect-[1/1] w-full rounded-large object-cover" src={t5} alt={t6} width={400} height={400} preload={priority} sizes="(max-width: 768px) 50vw, 33vw" />;
    $[6] = priority;
    $[7] = t5;
    $[8] = t6;
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  let t8;
  if ($[10] !== onGiftLinkClick || $[11] !== t4 || $[12] !== t7) {
    t8 = <CustomLink href={t4} aria-label={"\uB2F5\uB840\uD488 \uC0C1\uC138 \uD398\uC774\uC9C0\uB85C \uC774\uB3D9"} onClick={onGiftLinkClick}>{t7}</CustomLink>;
    $[10] = onGiftLinkClick;
    $[11] = t4;
    $[12] = t7;
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  let t9;
  if ($[14] !== isSoldOut) {
    t9 = isSoldOut ? <div className="absolute inset-0 z-[1] rounded-large bg-Gray-black/40 flex-center"><span className="font-700 text-Gray-white typo-body2">품절되었어요</span></div> : null;
    $[14] = isSoldOut;
    $[15] = t9;
  } else {
    t9 = $[15];
  }
  let t10;
  if ($[16] !== isAdult) {
    t10 = isAdult ? <div className="absolute bottom-12 right-12 z-10 rounded-xsmall bg-B-500 px-6 py-2 font-600 text-Gray-white typo-caption1">19세성인인증</div> : null;
    $[16] = isAdult;
    $[17] = t10;
  } else {
    t10 = $[17];
  }
  let t11;
  if ($[18] !== t10 || $[19] !== t3 || $[20] !== t8 || $[21] !== t9) {
    t11 = <div className="relative shrink-0">{t3}{t8}{t9}{t10}</div>;
    $[18] = t10;
    $[19] = t3;
    $[20] = t8;
    $[21] = t9;
    $[22] = t11;
  } else {
    t11 = $[22];
  }
  let t12;
  if ($[23] !== institution) {
    t12 = institution && <CustomLink href={DONATION_ROUTES.HOMETOWNS_DETAIL.pathname({
      id: institution.id
    })} aria-label={"\uC9C0\uC790\uCCB4 \uC0C1\uC138 \uD398\uC774\uC9C0\uB85C \uC774\uB3D9"} className="inline-block"><div className="mb-4 flex items-center gap-4"><div className="relative size-20 overflow-hidden rounded-pill border border-Gray-300"><Image className="object-cover" src={institution.logoUrl || "/images/placeholder.png"} alt={institution.name || "\uC9C0\uC790\uCCB4 \uB85C\uACE0"} width={20} height={20} sizes="20px" /></div><p className="mt-1 font-600 text-Gray-600 typo-caption1">{institution.name}</p><SvgChevronright className="size-12 text-Gray-600" /></div></CustomLink>;
    $[23] = institution;
    $[24] = t12;
  } else {
    t12 = $[24];
  }
  let t13;
  if ($[25] !== productNumber) {
    t13 = DONATION_ROUTES.GIFTS_DETAIL.pathname({
      productNumber
    });
    $[25] = productNumber;
    $[26] = t13;
  } else {
    t13 = $[26];
  }
  let t14;
  if ($[27] !== onGiftLinkClick || $[28] !== t13 || $[29] !== title) {
    t14 = <CustomLink href={t13} aria-label={"\uB2F5\uB840\uD488 \uC0C1\uC138 \uD398\uC774\uC9C0\uB85C \uC774\uB3D9"} className="mb-4 line-clamp-2 overflow-hidden text-ellipsis font-500 text-Gray-900 typo-body4" onClick={onGiftLinkClick}>{title}</CustomLink>;
    $[27] = onGiftLinkClick;
    $[28] = t13;
    $[29] = title;
    $[30] = t14;
  } else {
    t14 = $[30];
  }
  let t15;
  if ($[31] !== donationAmount) {
    t15 = donationAmount !== undefined ? <p className="flex items-center gap-4 font-600 text-Gray-black typo-body3"><span>{donationAmount.toLocaleString()}원</span><span className="text-Gray-550 typo-body4">기부시 증정</span></p> : null;
    $[31] = donationAmount;
    $[32] = t15;
  } else {
    t15 = $[32];
  }
  let t16;
  if ($[33] !== reviewCount || $[34] !== reviewRating) {
    t16 = reviewCount > 0 ? <div className="flex flex-wrap gap-4 pt-4 font-400 text-Gray-600 typo-caption2"><Rating value={reviewRating} count={reviewCount} /></div> : null;
    $[33] = reviewCount;
    $[34] = reviewRating;
    $[35] = t16;
  } else {
    t16 = $[35];
  }
  let t17;
  if ($[36] !== t12 || $[37] !== t14 || $[38] !== t15 || $[39] !== t16) {
    t17 = <div className="grow">{t12}{t14}{t15}{t16}</div>;
    $[36] = t12;
    $[37] = t14;
    $[38] = t15;
    $[39] = t16;
    $[40] = t17;
  } else {
    t17 = $[40];
  }
  let t18;
  if ($[41] !== t11 || $[42] !== t17 || $[43] !== t2) {
    t18 = <article className={t2}>{t11}{t17}</article>;
    $[41] = t11;
    $[42] = t17;
    $[43] = t2;
    $[44] = t18;
  } else {
    t18 = $[44];
  }
  return t18;
};